import {ActionReducerMapBuilder, createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {RootState} from "../../app/store";
import {getCircleSrc, LoginUserWithAccount} from "../../services/UsersService";
import {searchLoginUsers as searchLoginUsersService} from "./LoginUsersService";

export interface LoginUsersListState {
  loginUsers: LoginUserWithAccount[];
}

const initialState = {
  loginUsers: []
};

export const searchLoginUsers = createAsyncThunk<LoginUserWithAccount[], {email: string}>(
  "loginUsersList/searchLoginUsers",
  async (action) => {
    return searchLoginUsersService(action.email);
  }
);

const extraReducers = (builder: ActionReducerMapBuilder<LoginUsersListState>) => {
  builder.addCase(searchLoginUsers.fulfilled, (draft, action) => {
    draft.loginUsers = action.payload.map((l) => ({...l, circleSrc: getCircleSrc(l.importance)}));
  });
};

const LoginUsersListSlice = createSlice({
  name: "loginUsersList",
  initialState,
  reducers: {},
  extraReducers
});

export default LoginUsersListSlice.reducer;

export const loginUsersListState = (state: RootState): LoginUsersListState => state.loginUsersList;
